import { useEffect, useState } from "react";
import CarritoCompras from "../components/CarritoCompras";
import Header from "../components/layout/Header";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../helpers/Routes";
import { useProductos } from "../hooks/useProductos";
import api from "../config/axios";

const PaySuccess = () => {
    const [transaction, setTransaction] = useState(null);
    const [openCart, setOpenCart] = useState(false);
    const [sendEmail, setSendEmail] = useState("");
    const { cart, orden, getOrden } = useProductos();
    const [city] = useState("");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refPayco = searchParams.get('ref_payco');
    const orderId = searchParams.get('orderId');



    useEffect(() => {
        if (refPayco) {
            // Consultar el estado del pago usando la API de ePayco
            fetch(`https://secure.epayco.co/validation/v1/reference/${refPayco}`)
                .then((response) => response.json())
                .then((data) => {
                    setTransaction(data);
                })
                .catch((error) => {
                    console.error('Error al validar el pago:', error);
                    setTransaction(error);
                });
        }
        // Obtener la orden por orderId si existe
        if (orderId) {
            getOrden(orderId);
        }
    }, [location.search]);

    // Ya no es necesario buscar la orden por x_id_factura, ahora usamos orderId


    console.log(orden)
    let acum_cant = 0;
    cart?.forEach(item => {
        acum_cant = acum_cant + item.cantidad;
    });

    const processedTransactions = JSON.parse(localStorage.getItem("facturasProcesadas") || "[]");

    useEffect(() => {
        if (
            transaction?.data?.x_transaction_state === "Aceptada" &&
            refPayco && orden?.first_name && orden?.email
        ) {
            // Email HTML bonito
            setSendEmail(`
                <div style="font-family: Arial, sans-serif; background: #f7f7f7; padding: 32px; color: #222;">
                  <div style="max-width: 600px; margin: 0 auto; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.07); padding: 32px;">
                    <h2 style="color: #0a7cff; text-align: center;">¡Gracias por tu compra!</h2>
                    <p style="font-size: 1.1em;">Hola <b>${orden?.first_name} ${orden?.last_name}</b>,</p>
                    <p>Tu pedido ha sido recibido y está siendo procesado. Aquí tienes los detalles de tu orden:</p>
                    
                    <div style="background-color: #f8f9fa; border-radius: 8px; padding: 16px; margin: 24px 0;">
                      <h3 style="color: #0a7cff; margin-top: 0;">Productos Comprados</h3>
                      ${orden?.bicycles?.map(bike => `
                        <div style="border-bottom: 1px solid #eee; padding: 12px 0;">
                          <p style="margin: 0; font-weight: bold;">${bike.name}</p>
                          <p style="margin: 4px 0; color: #666;">
                            Cantidad: ${bike.pivot.quantity} | 
                            Precio: ${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(bike.pivot.price)}
                          </p>
                        </div>
                      `).join('') || ''}
                      
                      ${orden?.skateboards?.map(skate => `
                        <div style="border-bottom: 1px solid #eee; padding: 12px 0;">
                          <p style="margin: 0; font-weight: bold;">${skate.name}</p>
                          <p style="margin: 4px 0; color: #666;">
                            Cantidad: ${skate.pivot.quantity} | 
                            Precio: ${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(skate.pivot.price)}
                          </p>
                        </div>
                      `).join('') || ''}
                    </div>

                    <table style="width: 100%; border-collapse: collapse; margin: 24px 0;">
                      <tr><td style="padding: 8px; font-weight: bold;">Número de Orden:</td><td style="padding: 8px;">${orden?.id}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Nombre:</td><td style="padding: 8px;">${orden?.first_name} ${orden?.last_name}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Cédula:</td><td style="padding: 8px;">${orden?.cedula}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Teléfono:</td><td style="padding: 8px;">${orden?.phone}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Ciudad:</td><td style="padding: 8px;">${orden?.city}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Dirección:</td><td style="padding: 8px;">${orden?.address}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Envío:</td><td style="padding: 8px;">${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(orden?.shipping_price)}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Total:</td><td style="padding: 8px; color: #0a7cff; font-weight: bold;">${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(orden?.total_price)}</td></tr>
                      <tr><td style="padding: 8px; font-weight: bold;">Método de entrega:</td><td style="padding: 8px;">${orden?.status === 'pendiente' ? 'Por confirmar' : orden?.status}</td></tr>
                    </table>

                    <div style="background-color: #fff7e6; border-left: 4px solid #ffb700; padding: 16px; margin-top: 24px;">
                      <p style="margin: 0; color: #b37400;"><strong>Importante:</strong> ${orden?.deliveryMethod === 'pickup' ? 
                        'Has seleccionado recoger en tienda. Presenta tu número de orden cuando vengas a recoger tu pedido.' : 
                        'Tu pedido será enviado a la dirección proporcionada. Te notificaremos cuando sea despachado.'}
                      </p>
                    </div>

                    <p style="margin-top: 24px;">Si tienes alguna pregunta, responde a este correo o contáctanos a través de nuestra web.</p>
                    <p style="color: #888; font-size: 0.95em; margin-top: 32px;">Bicicletas Java Colombia</p>
                  </div>
                </div>
            `);
        }
    }, [orden, transaction, refPayco]);


    useEffect(() => {
        if (sendEmail?.trim() !== "") {
            const MAIL_API = import.meta.env.VITE_MAIL_API || process.env.VITE_MAIL_API;
            fetch(`${MAIL_API}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    toEmail: orden?.email,
                    subject: "Confirmación de compra",
                    message: sendEmail,
                })
            })
            .then(response => response.json())
            .then(data => {
                localStorage.setItem("facturasProcesadas", JSON.stringify(processedTransactions));
                console.log("mensaje enviado por correo electronico", data);
            })
            .catch(error => {
                console.log("Error al enviar el correo:", error);
            })
        }
    }, [sendEmail]);

    const descuento = async () => {
        await Promise.all(
            cart?.map(async (item) => {
                await api.put(`/productos/${item?.id}`, {
                    id: item?.id,
                    cantidadDescuento: item?.cantidad
                });
            })
        )
    }

   useEffect(() => {
  if (
    typeof window !== "undefined" &&
    transaction?.data?.x_transaction_state === "Aceptada" &&
    orden
  ) {
    // 🔹 Actualiza la orden en backend
    api.put(`/orders/${orden?.norden}`, {
      id: orden?.norden
    })
    .then(response => console.log("Orden actualizada:", response))
    .catch(error => console.log("Error al actualizar orden:", error));

    // 🔹 Descuenta inventario
    descuento();

    // 🔹 ENVÍA EVENTO A GOOGLE TAG MANAGER
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: orden.id,
        affiliation: "Bicicletas Java Colombia",
        value: orden.total_price,
        currency: "COP",
        items: [
          ...(orden?.bicycles?.map((bike) => ({
            item_id: bike.id,
            item_name: bike.name,
            price: bike.pivot.price,
            quantity: bike.pivot.quantity,
            category: "Bicicletas",
          })) || []),
          ...(orden?.skateboards?.map((skate) => ({
            item_id: skate.id,
            item_name: skate.name,
            price: skate.pivot.price,
            quantity: skate.pivot.quantity,
            category: "Skateboards",
          })) || []),
        ],
      },
    });
  }
}, []);

    console.log(sendEmail)
    const handlePrint = () => {
        window.print();
    };


    return (
        <>
            <Header />
            <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
            <div className="wrapper" style={{ margin: "100px auto", background: "#000000" }}>
                <div className="container-preview" style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <div className="receipt-container">
                        <h2 className="receipt-title">Transacción {transaction?.data.x_transaction_state}</h2>
                        <div className="receipt-content">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Empresa:</td>
                                        <td>{transaction?.data.x_business || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Valor:</td>
                                        <td>{transaction?.data.x_amount ? new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(transaction?.data.x_amount) : "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha y hora:</td>
                                        <td>{transaction?.data.x_fecha_transaccion || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Número de recibo:</td>
                                        <td>{transaction?.data.x_id_factura || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Descripción:</td>
                                        <td>{transaction?.data.x_description ? "Pago de " + transaction?.data.x_description : "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Estado de transacción:</td>
                                        <td style={{ fontWeight: "bold", textTransform: "uppercase" }}>{transaction?.data.x_transaction_state || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Referencia ePayco:</td>
                                        <td>{transaction?.data.x_ref_payco || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>IP origen:</td>
                                        <td>{transaction?.data.x_customer_ip || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Autorización CUS:</td>
                                        <td>{transaction?.data.x_approval_code || "Sin información"}</td>
                                    </tr>
                                    {orden?.isPickup && (
                                        <tr>
                                            <td>Método de entrega:</td>
                                            <td style={{ 
                                                fontWeight: "bold", 
                                                color: "#ffdd00", 
                                                backgroundColor: "#333",
                                                padding: "10px",
                                                borderRadius: "5px"
                                            }}>
                                                RECOGIDA EN TIENDA
                                                <div style={{ fontSize: "0.9em", color: "#fff", marginTop: "5px" }}>
                                                    Presenta tu ID de orden en nuestro local para recoger tu producto
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="receipt-actions">
                            {transaction?.data.x_transaction_state === "Aceptada" && (
                                <button className="print-button" onClick={handlePrint}>Imprimir o guardar</button>
                            )}
                            <Link to={routes.home} className="finalize-button">Regresar al comercio</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaySuccess;